import React from 'react';
import './App.css';
import PitchButtons from './components/PitchButtons';

function App() {
    return (
        <div className="App">
            <PitchButtons />
        </div>
    );
}

export default App;
